<template>
  <el-dialog title="Editar Visita" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="40%">
    <el-form size="small" label-position="top">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="Data">
            <el-input v-model="data" v-mask="'##/##/####'"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item class="form-item" label="Hora">
            <el-input v-model="hora" v-mask="'##:##'"></el-input> 
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Cliente" style="width: 100%">
            <el-input v-model="this.cliente.nome" readonly/>
          </el-form-item>
        </el-col>
      </el-row>      

      <el-form-item label="Atendente" style="width: 100%">
        <el-select
          v-model="visita.usuario"
          :remote-method="filtrarUsuariosSelect"
          :loading="loadingUsuarios"
          value-key="id"
          placeholder=""
          loading-text="Carregando usuários"
          no-data-text="Nenhum usuário encontrado"
          filterable
          remote
          reserve-keyword
          style="width: 100%">
          <el-option
            v-for="item in usuariosDisponiveis"
            :key="item.id"
            :label="item.nome"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <h1 style="margin: 5px 0px 0px 0px; text-align: left;">-Imóveis</h1>
      <el-row style="height: 40%; padding: 5px 0px;">
        <el-col :span="24" style="height: 100%">
          <el-container style="height: 100%">
            <el-main style="padding: 0px; height: 100%">
              <el-table
                :data="imoveis"
                empty-text="Nenhum imovel cadastrado"
                width="100%"
                max-height="250"
                size="small"
                style="background-color: #FFFFFF; border: solid 1px #DBDFE5; border-radius: 5px;"
                stripe
                highlight-current-row>
                <el-table-column label="Endereço" width="250" prop="endereco"/>
                <el-table-column label="Número" width="90" prop="numeroEndereco"/>
                <el-table-column>
                  <template slot-scope="scope">
                    <el-button 
                      @click.native.prevent="removerImovelSelecionado(scope.row)"
                      type="text" 
                      size="small" 
                      style="padding: 0px; color: #F56C6C;">Remover</el-button>
                  </template>
                </el-table-column> 
              </el-table>
            </el-main>
          </el-container>
        </el-col>
      </el-row>

      <el-form-item label="Descrição">
        <el-input rows="6" type="textarea" v-model="visita.descricao"/>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="fechar">Fechar</el-button>
      <el-button @click="gravar" type="primary">Gravar</el-button>
    </span>

  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    visita: Object,
    data: String,
    hora: String,
    imoveisVisita: Object,
    visibility: Boolean
  },
  data() {
    return {
      loadingImoveis: false,
      loadingUsuarios: false,

      usuario: {},
    }
  },
  computed: {
    ...mapState('clientesStore', {
      cliente(state) { return state.clienteSelecionado },
      usuariosDisponiveis(state) { return state.usuariosDisponiveis }
      }),
      imoveis(){
        return this.imoveisVisita.imoveis;
      }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('clientesStore', [
      'listarUsuarios',
      'gravarVisita',
      'recuperarVisita'
    ]),
    gravar() {
      this.visita.dataHora = this.data + " " + this.hora;
      this.visita.imoveis = this.imoveis;
      this.showLoading();

      //criar endpoint Clientes/gravarVisita na API
      this.gravarVisita(this.visita)
      .then((resultado) => {
        this.hideLoading();
        
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      })
    },
    filtrarUsuariosSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      })
    },    
    removerImovelSelecionado(imovel) {
      var i;
      for(i=0;i<this.imoveis.length;i++){
        if(this.imoveis[i].id == imovel.id){
          this.imoveis.splice(i, 1);
        }
      }
    },
    fechar() {
      this.$emit('close');
    }    
  }
}
</script>

